<template>
  <div class="container">
    <nav-header ref="navHeader"></nav-header>

    <div class="bg" :style="`background-image: url(${previewPic});`"></div>
    <div class="bg bg-blur"></div>

    <!-- 主要内容 -->
    <div v-if="liveInfo" class="main">
      <div class="left">
        <div class="info">
          <!-- 直播间标题和观看人数 -->
          <div class="info-left">
            <el-tooltip
              class="item"
              effect="dark"
              :content="liveInfo.name"
              placement="top"
            >
              <!-- 标题 -->
              <div class="info-left-title text-long-ellipsis">
                {{ liveInfo.name }}
              </div>
            </el-tooltip>

            <div class="info-left-num">
              <!-- 观看人数 -->
              <div class="watch">
                <i class="el-icon-s-custom"></i>
                <div class="title">{{ message.pvCount }}人观看</div>
              </div>

              <div
                v-if="
                  !isCountdownOver &&
                  liveInfo.status === 0 &&
                  liveInfo.startTime
                "
                class="live-countdown"
              >
                <i class="el-icon-timer timer-icon"></i>
                <div class="title">直播倒计时</div>
                <Countdown
                  :endTime="liveInfo.startTime"
                  @over="countdownOver"
                ></Countdown>
              </div>
            </div>
          </div>
          <!-- / 直播间标题和观看人数 -->
          <!-- 直播状态 -->
          <div class="info-right">
            <span class="status">
              <div
                class="circle"
                :style="`background-color: ${statusBg || '#999'};`"
              ></div>
              <span class="title" :style="`color: ${statusBg || '#999'};`">{{
                statusTitle
              }}</span>
            </span>
          </div>
          <!-- / 直播状态 -->
        </div>

        <!-- 视频 -->
        <div class="player-area">
          <div class="player-main">
            <div class="player">
              <div class="player-box">
                <div
                  v-if="!isPlay"
                  class="preview-pic"
                  :style="`cursor: ${
                    isCanPaly ? 'pointer' : 'default'
                  };pointer-events: ${!phoneWatchStauts ? 'none' : 'auto'}`"
                >
                  <!-- 预览图（封面图） -->
                  <preview-pic
                    :style="`pointer-events: ${
                      !phoneWatchStauts ? 'none' : 'auto'
                    }`"
                    :image="previewPic"
                    @click.native="clickPreview"
                  ></preview-pic>
                </div>
                <!-- 普通视频 -->
                <ali-player
                  v-if="isPlay && !vrplayer"
                  :source="source"
                  :status="liveInfo.status"
                ></ali-player>
                <!-- vr视频 -->
                <vrPlayer
                  v-if="isPlay && vrplayer"
                  ref="myVideo"
                  :videoSrc="source"
                  :status="liveInfo.status"
                ></vrPlayer>
              </div>
            </div>
          </div>

          <!-- 点赞动画 -->
          <div class="like-box" @click="addLike">
            <likeBtn ref="likeBtn" :likeCount="message.likeCount.toString()" />
          </div>
        </div>
        <!-- / 视频 -->

        <!-- 直播窗口下方手机扫码观看等菜单栏 -->
        <div class="phone-watch">
          <div class="qrcode-box">
            <Qrcode
              v-if="qrcode.url"
              :url="qrcode.url"
              :show="qrcode.show"
              :icon="qrcode.icon"
              style="float: right"
            ></Qrcode>
          </div>
        </div>
        <!-- / 直播窗口下方手机扫码观看等菜单栏 -->
      </div>

      <!-- 聊天窗 -->
      <div v-if="isChat" class="right">
        <chat ref="chatRef" :liveId="liveId" @send="sendMessage"></chat>
      </div>
    </div>

    <!-- 直播间有多个流时 -->
    <div
      v-if="liveInfo && liveInfo.sourceList.length > 1"
      class="source-list-box menu"
    >
      <source-swiper
        :list="liveInfo.sourceList"
        :current="currentIndex"
        @change="changeLive"
      ></source-swiper>
    </div>

    <!-- 直播详情等内容 -->
    <div v-if="isShowDesc" class="container-box menu">
      <el-tabs
        v-if="menuList.length"
        v-model="activeName"
        class="live-tab-item"
      >
        <el-tab-pane
          v-for="(item, index) in menuList"
          :key="index"
          :label="item.name"
          :name="item.name"
        >
          <div class="description-box">
            <div
              class="description"
              v-html="item.value || liveInfo.description"
            ></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- / 直播详情等内容 -->

    <PhoneWatch
      v-if="!phoneWatchStauts && qrcode.url"
      :url="qrcode.url"
      :show="true"
      :icon="qrcode.icon"
    ></PhoneWatch>

    <PasswordPopup
      v-if="needPasswordStauts"
      :password="
        (liveInfo &&
          liveInfo.style &&
          liveInfo.style.player &&
          liveInfo.style.player.password) ||
        ''
      "
    >
    </PasswordPopup>
    <h1></h1>
  </div>
</template>

<script>
  import * as Api from '@/api';
  import websocketFeature from '@/api/websocket.js';
  import * as Utils from '@/utils/utils.js';
  import { wxShare } from '@/utils/wxShare/getWxApi.js';
  import navHeader from '@/components/navHeader.vue';
  import aliPlayer from '@/components/aliplayer/aliplayer.vue';
  import vrPlayer from '@/components/vrPlayer/index.vue';
  import sourceSwiper from './components/swiper/index.vue';
  import previewPic from '@/components/previewPic/index.vue';
  import Qrcode from '@/components/Qrcode/index.vue';
  import PhoneWatch from '@/components/PhoneWatch/index.vue';
  import PasswordPopup from '@/components/PasswordPopup/index.vue';
  import chat from '@/components/chat/index.vue';
  import likeBtn from '@/components/likeBtn/index.vue';
  import Countdown from '@/components/countdown/index.vue';
  import _ from 'lodash';
  import { Base64 } from 'js-base64';
  import * as memberPoints from '@/utils/memberPoints/index.js';

  /* import Vue from 'vue' // TODO 测试用
  import vconsole from 'vconsole' // TODO 测试用
  if (process.env.NODE_ENV === 'development') {
    const Vconsole = new vconsole()
    Vue.use(Vconsole)
  } */

  export default {
    components: {
      navHeader,
      aliPlayer,
      vrPlayer,
      sourceSwiper,
      previewPic,
      chat,
      likeBtn,
      Countdown,
      Qrcode,
      PhoneWatch,
      PasswordPopup,
    },
    name: 'LiveIndex',

    data() {
      return {
        liveId: '', // 直播间ID
        activeName: '直播详情', // 当前选中的标签页

        liveInfo: null, // 直播间详情
        currentIndex: 0, // 当前直播房间索引
        isPlay: false, // 点击播放

        userInfo: {
          // 用户信息
          id: null,
          fullName: null,
          thumb: null,
        },

        likeObj: {
          praiseBubble: null, // 点赞动画元素
          tmpLikeCount: 0, // 临时点赞次数
          likeTime: null, // 点赞延时器
        },

        qrcode: {
          url: '', // 二维码地址
          icon: '', // 二维码中间的icon图标
          show: false, // 二维码是否显示
        },

        myWebsocketKey: '', // websocket 链接

        isCountdownOver: true, // 倒计时是否结束
        message: {
          pvCount: 0, // 浏览量
          likeCount: 0, // 点赞数,
        }, // ws信息
      };
    },

    computed: {
      // 预览图
      previewPic() {
        if (!this.liveInfo) return '';

        return this.liveInfo.sourceList.length > 1
          ? this.liveInfo.sourceList[this.currentIndex].picUrl
          : this.liveInfo.previewPicUrl;
      },
      // 直播状态是否能播放 直播中/回放中
      isCanPaly() {
        // 直播状态 0-未直播|1-直播中|2-已结束|3-回放中
        return (
          Number(this.liveInfo.status) === 1 ||
          Number(this.liveInfo.status) === 3
        );
      },
      // 直播状态背景色
      statusBg() {
        let data = {
          0: '#999',
          1: 'green',
          2: '#ff3b3b',
          3: '#fff',
        };
        const status = Number(this.liveInfo.status);
        return data[status];
      },
      // 直播状态标题
      statusTitle() {
        let data = {
          0: '未直播',
          1: '直播中',
          2: '直播已结束',
          3: '回放中',
        };
        const status = Number(this.liveInfo.status);
        return data[status];
      },
      // 播放源
      source() {
        if (
          this.liveInfo.sourceList.length === 0 ||
          Number(this.liveInfo.status) === 3
        ) {
          return this.liveInfo.url || '';
        }
        return this.liveInfo.sourceList[this.currentIndex].streams[0].url;
      },
      // 是否启用聊天室
      isChat() {
        if (!this.liveInfo) return;

        if (this.liveInfo.style && this.liveInfo.style.menu) {
          return this.handleMenu(1);
        }

        // 兼容旧数据
        return this.liveInfo.paid === 0;
      },
      // 是否启用直播介绍
      isShowDesc() {
        if (!this.liveInfo) return;

        if (this.liveInfo.style && this.liveInfo.style.menu) {
          return this.handleMenu(2);
        }

        // 兼容旧数据
        return this.liveInfo.description;
      },
      // 设备锁（根据页面路由传参控制PC端或者移动端打开直播间）
      type() {
        // all pc h5
        return this.$route.query.type || 'all';
      },
      // 根据url传参player=vr，识别是vr直播
      vrplayer() {
        return this.$route.query.player && this.$route.query.player === 'vr';
      },
      // 菜单列表
      menuList() {
        if (!this.liveInfo) return [];
        let arr = [];

        if (!this.liveInfo.style) {
          // 兼容旧数据
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.activeName = '直播详情';
          return [
            { name: '直播详情', type: 2, value: this.liveInfo.description },
          ];
        }

        // 自定义菜单有内容时过滤掉聊天室
        if (this.liveInfo.style.menu.length > 0) {
          // 自定义菜单，初始化选择第一个
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.activeName = this.liveInfo.style.menu.find(
            (item) => item.type === 2,
          ).name;
          arr = JSON.parse(JSON.stringify(this.liveInfo.style.menu));
          arr = arr.filter((item) => item.type !== 1);
        }

        return arr;
      },

      /**
       * 获取路由是否，必须允许PC观看
       * @description 判断参数style.player.needPc, true 是允许PC观看， false 不允许PC观看
       */
      phoneWatchStauts() {
        if (!this.liveInfo) return false;
        let phoneWatch = false;
        phoneWatch =
          this.liveInfo.style &&
          this.liveInfo.style.player &&
          this.liveInfo.style.player.needPc
            ? this.liveInfo.style.player.needPc
            : false;

        return phoneWatch;
      },
      /**
       * 直播间是否需要密码观看
       * @description 判断参数style.player.needPassword, true 是需要密码观看， false 不需要密码观看
       */
      needPasswordStauts() {
        if (!this.liveInfo) return false;
        let needPassword = false;
        needPassword =
          this.liveInfo.style &&
          this.liveInfo.style.player &&
          this.liveInfo.style.player.needPassword
            ? this.liveInfo.style.player.needPassword
            : false;
        return needPassword;
      },
    },

    watch: {
      /**
       * 路由监听
       * @param{Number} id 直播间id 必传
       * @param{String} type 设备锁（根据页面路由传参控制PC端或者移动端打开直播间），默认：all，参数：all pc h5
       * @param{String} player 根据url传参player=vr，识别是vr直播，默认："，参数：""/vr
       */
      async $route() {
        await this.init_load();
        this.removeWebSock();
        this.createWebSock();
      },
      'liveInfo.status'(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.isPlay = false;
        }
      },
    },

    async mounted() {
      await this.init_load();
      this.liveId && this.createWebSock(); // 如果强制要求APP查看则不请求ws
      memberPoints.main('live-pc'); // 埋点访问量
    },

    destroyed() {
      this.removeWebSock();
    },

    methods: {
      async init_load() {
        this.resetData(); // 重置数据

        const hasId = this.getRoomId(); // 根据路由获取直播间ID
        if (!hasId) return;

        await this.getLiveDetail();

        try {
          await wxShare();
          if (!this.liveInfo.isShared) this.disableShare();
        } catch (e) {
          return Promise.reject(new Error(e));
        }
      },

      /**
       * 根据路由获取直播间ID
       */
      getRoomId() {
        const id = this.$route.query.id;
        if (!id) {
          this.$message.error('直播间ID缺失');
          return false;
        }

        this.liveId = id;
        return true;
      },
      /**
       * 点击播放
       */
      clickPreview: _.debounce(
        async function () {
          const that = this;
          await that.getLiveDetail();
          if (that.isCanPaly) {
            that.isPlay = true;
          }
        },
        1000,
        { leading: true, trailing: false },
      ),
      /**
       * 创建新的websocket
       */
      createWebSock() {
        if (!this.phoneWatchStauts) return;

        const url = `wss://live.wxls.pro/chatws?roomId=${this.liveId}&accessToken=${this.$store.getters.token}&ua=${navigator.userAgent}`;

        try {
          this.myWebsocketKey = websocketFeature.create(
            url,
            this.websocketMessageHandler.bind(this),
          );
        } catch (error) {
          console.log('websocket创建错误---', error);
        }
      },
      /**
       * 根据key删除websocket实例，并关闭连接
       */
      removeWebSock() {
        websocketFeature.remove(this.myWebsocketKey);
      },
      /**
       * 创建websocket后的回调
       * @param {event} e
       */
      websocketMessageHandler(e) {
        if (e.data === 'pong') return;
        let data = e.data;

        // 判断是base64就解码
        if (Utils.isBase64(data)) {
          data = Base64.decode(data);
        }
        data = JSON.parse(data);

        console.log('zzzzzzzzzzzz', data);

        this.message = { ...this.message, ...data };
        switch (data.messageType) {
          case '1':
          case '9':
            // 留言
            this.getMessage(data);
            break;
          case '2':
            // 删除
            this.deleteMessage(data.messageId);
            break;
          case '3':
            // 关闭连接
            this.removeWebSock();
            break;
          case '5':
            // 错误信息
            this.$message.error(data.content);
            break;
          case '6':
          case '7':
            // 点赞 / 加入直播间
            this.message.likeCount = data.likeCount2;
            this.message.pvCount = data.pvCount2;
            break;
          case '8':
            // 直播间状态更新
            this.statusChange();
            break;
        }
      },
      /**
       * 直播间状态更新
       */
      statusChange() {
        this.getLiveDetail();
      },
      /**
       * 点赞
       */
      addLike: _.throttle(
        function () {
          const that = this;
          that.$refs.likeBtn.addPraise(); // 点赞动画

          that.likeObj.tmpLikeCount++;
          that.message.likeCount++;

          if (that.likeObj.likeTime) {
            clearTimeout(this.likeObj.likeTime);
          }
          that.likeObj.likeTime = setTimeout(() => {
            that.likeObj.likeTime = null;
            let data = {
              likeCount: that.likeObj.tmpLikeCount,
              messageType: 6,
              roomId: this.liveId,
              userId: this.userInfo.id,
            };
            data = Base64.encode(JSON.stringify(data)); //加密
            websocketFeature.send(this.myWebsocketKey, data);
            that.likeObj.tmpLikeCount = 0;
          }, 2000);
        },
        300,
        { trailing: false },
      ),
      /**
       * 删除留言
       * @param {String} messageId 留言id
       */
      deleteMessage(messageId) {
        this.$refs.chatRef.deleteMessage(messageId);
      },
      /**
       * socket留言
       * @param {Object} data 留言的信息
       */
      getMessage(data) {
        this.$refs.chatRef.getMessage(data);
      },
      /**
       * 发留言
       * @param {Object} obj obj.content 留言内容, obj.replyItem 存在就是被回复的留言
       */
      sendMessage(obj) {
        let data = {
          messageType: 1, // 1发2删3关闭连接
          // "messageId":new Date().getTime()+'23555',
          content: obj.content,
          userId: this.userInfo.id,
          username: this.userInfo.fullName, // 评论回复者id
          roomId: this.liveId,
          profileUrl: this.userInfo.thumb,
          accessToken: this.$store.getters.token,
          timestamp: new Date().getTime(),
        };

        if (obj.replyItem) {
          data = {
            ...data,
            messageType: 9,
            messageId: obj.replyItem.messageId, // 回复的消息id
            targetUserId: obj.replyItem.userId,
            extra: obj.replyItem.userId,
          };
        }

        data = Base64.encode(JSON.stringify(data)); // Base64加密
        const isSend = websocketFeature.send(this.myWebsocketKey, data);

        if (isSend && this.liveInfo.chatMode === 1) {
          // 留言内容chatMode为0不需要审核，为1要审核
          this.$message('发送成功，请等待审核通过！');
        }

        this.$refs.chatRef.clearInput();
      },
      /**
       * 获取直播间详情
       */
      async getLiveDetail() {
        try {
          const { data: res } = await Api.live.getLive(this.liveId);
          if (res.isDelete) {
            this.toNoPage();
            return;
          }

          const isPhone = this.checkPhonePc(res.type); // 判断是否手机端打开
          if (isPhone) return;

          res.sourceList.forEach((item) => {
            // 筛选urlType为2的直播流
            item.streams = item.streams.filter((el) => el.urlType === 2);
          });
          res.style = JSON.parse(res.style);
          // console.log('res.style---', res.style)
          this.liveInfo = res;
          document.title = res.name;
          this.checkMobileType();
          this.checkStartTime();
        } catch (error) {}
      },
      /**
       * 禁用微信浏览器分享
       */
      disableShare() {
        function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
        }
        if (typeof WeixinJSBridge == 'undefined') {
          if (document.addEventListener) {
            document.addEventListener(
              'WeixinJSBridgeReady',
              onBridgeReady,
              false,
            );
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },

      /**
       * url传参type就根据传参打开指定，否则自动判断设备打开PC端或H5，页面没有传参就根据设备判断是PC或APP打开指定端
       * @param {String} type 直播间横竖屏type
       */
      checkPhonePc(type) {
        if (this.type === 'h5') {
          window.location.href = this.h5Url(type);
          return true;
        }

        if (this.type === 'pc') return false;

        return this.isPhone(type); // 判断是否手机端打开
      },
      /**
       * 判断设备是否手机端，是APP端则根据type跳转横屏或者竖屏地址
       * @param {string} type 0 是横屏 1是竖屏
       * @returns {Boolean} true 是手机端 false 是PC端
       */
      isPhone(type) {
        const data = Utils.isPhone();
        if (data) {
          window.location.href = this.h5Url(type);
        }
        return data;
      },
      /**
       * 手机扫码观看
       */
      checkMobileType() {
        // type 0 是横屏 1是竖屏
        this.qrcode.url = this.h5Url(this.liveInfo.type);
      },
      /**
       * 根据接口里的type值判断是跳转APP的横屏或是竖屏地址
       * @param {Number} type 0 是横屏 1是竖屏
       */
      h5Url(type) {
        // type 0 是横屏 1是竖屏
        const rowUrl = `https://wap2.wxls.pro/live2022/#/pages/index/index?id=${this.liveId}`;
        const columnUrl = `https://wap2.wxls.pro/live2022/#/pages/index/verticalIndex?id=${this.liveId}`;
        return type === 1 ? columnUrl : rowUrl;
      },
      /**
       * 更换直播间
       */
      changeLive(e) {
        this.currentIndex = e;
      },

      /**
       * 重置数据
       */
      resetData() {
        this.isPlay = false;
        this.currentIndex = 0;
        this.userInfo = this.$store.getters.userInfo;
      },
      /**
       * 检查直播开始时间
       */
      checkStartTime() {
        let time = this.$moment(this.liveInfo.startTime).diff(this.$moment());
        this.isCountdownOver = time <= 0;
      },
      /**
       * 倒计时结束得回调
       */
      countdownOver() {
        console.log('倒计时结束得回调');
        this.isCountdownOver = true;
        this.isMore = true;
        this.init_load();
        this.removeWebSock();
        this.createWebSock();
      },

      /**
       * 处理自定义菜单
       */
      handleMenu(type) {
        const arr = this.liveInfo.style.menu.map((item) => item.type);
        return arr.includes(type);
      },

      /**
       * 直播间删除，前往404
       */
      toNoPage() {
        window.location.href =
          'https://wap2.wxls.pro/yappDetails/#/index.html?id=111';
      },
    },
  };
</script>

<style lang="less" scoped>
  .container {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;
    color: #fff;
  }

  .bg {
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
  }
  .bg-blur {
    background: rgba(0, 0, 0, 0.6);
  }

  .main {
    margin: 16px 10% 0;
    height: 828px;
    display: flex;
    align-items: center;
  }
  .left {
    // flex: 1;
    width: 100%;
    padding: 0 13px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .info {
      .blackOpacity();
      border-radius: 8px 8px 0 0;
      height: 100%;
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info-left {
        width: 80%;
        margin-left: 10px;
      }
      .info-left-title {
        margin-top: 10px;
        font-size: 18px;
        font-weight: 500;
        color: #fff;
        line-height: 25px;
        height: 25px;
        text-align: left;
        cursor: default;
      }
      .info-left-num {
        display: flex;
        align-items: baseline;
      }
      .watch {
        vertical-align: middle;
        display: inline-block;
        height: 30px;
        border-radius: 17px;
        font-size: 13px;
        line-height: 30px;
        margin-right: 40px;
        display: flex;
        align-items: baseline;
        color: #7c7c7c;
        .title {
          vertical-align: middle;
        }
        .icon {
          margin-top: -3px;
          margin-right: 4px;
          display: inline-block;
          width: 18px;
          height: 18px;
          filter: brightness(0.5);
        }
        .el-icon-s-custom {
          width: 18px;
          height: 18px;
        }
      }
      .info-right {
        .status {
          display: inline-block;
          margin-right: 20px;
          height: 30px;
          border-radius: 17px;
          padding: 0 13px;
          font-size: 14px;
          line-height: 30px;
        }
      }

      .live-countdown {
        display: flex;
        align-items: center;
        .timer-icon {
          font-size: 19px;
          margin-right: 4px;
        }
        .title {
          font-size: 13px;
          color: #fff;
          font-weight: 400;
        }
      }
    }
    .player-area {
      position: relative;
      flex: 1;
      display: flex;
      align-items: center;
      overflow: hidden;
      .blackOpacity();
      .backdropFilter();
      .player-main {
        height: 100%;
        width: 100%;
      }
      .player {
        position: relative;
        height: 100%;
      }
      .player-box {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        overflow: hidden;
        background: #1e1e1e;
      }
    }
    .phone-watch {
      height: 60px;
      line-height: 60px;
    }
    .qrcode-box {
      padding: 0 20px;
      height: 100%;
      border-radius: 0 0 8px 8px;
      .blackOpacity();
      .backdropFilter();
    }
  }

  .preview-pic {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .circle {
    margin-right: 8px;
    vertical-align: middle;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    // background-color: @red;
  }
  .red {
    color: @red;
  }
  .right {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    float: right;
    padding-right: 10px;
    width: 30%;
  }

  .container-box {
    // margin: 0 22px;
    // width: calc(100% - 44px);
  }
  .menu {
    margin: 16px 10% 0;
  }
  .description-box {
    min-height: 800px;
    margin: 0 auto;
    border-radius: 0 0 6px 6px;
    .blackOpacity();
    .backdropFilter();
    .description {
      width: 80%;
      margin: 0 auto;
      height: 100%;
      overflow: auto;
      font-size: 12px;
      box-sizing: border-box;
      counter-reset: list-0;
      line-height: 1.42;
      height: 100%;
      outline: none;
      overflow-y: auto;
      padding: 12px 15px;
      tab-size: 4;
      text-align: left;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }

  .description {
    // padding: 0 20rpx 20rpx;
    line-height: 1.5;
    img,
    p,
    span {
      max-width: 100% !important;
      height: auto !important;
    }
  }

  .source-list-box {
    height: 150px;
    padding: 20px;
    border-radius: 6px;
    .blackOpacity();
    .backdropFilter();
  }

  .like-box {
    position: absolute;
    right: 30px;
    bottom: 50px;
  }

  /deep/ .el-tabs__nav-wrap {
    position: relative;
    display: flex;
    height: 72px;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
    padding: 0 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 auto;
    border-radius: 6px 6px 0 0;
    .blackOpacity();
    .backdropFilter();
  }

  /deep/ .el-tabs__header {
    margin: 0;
  }
  /deep/ .el-tabs__content {
    height: 100%;
  }
  /deep/ .el-tab-pane {
    height: 100%;
  }
  /deep/ .el-tabs__item {
    color: #fff;
    font-weight: 600;
  }
  /deep/ .el-tabs__active-bar {
    height: 4px;
    border-radius: 4px;
  }
  /deep/ .el-tabs__nav-wrap {
    display: flex;
    justify-content: center;
    &::after {
      background-color: transparent;
    }
  }

  @media screen and (max-width: 1335px) {
    .container {
      min-width: 1335px;
    }

    .main {
      height: 538px;
    }
    .main .right {
      width: 30%;
      height: 100%;
    }
  }
  @media screen and (min-width: 1336px) and (max-width: 1550px) {
    .main {
      height: 597px;
    }
    .right {
      width: 30%;
      height: 100%;
    }
  }

  @media screen and (min-width: 1551px) and (max-width: 1765px) {
    .main {
      height: 665px;
    }
    .main .left,
    .main .right {
      height: 100%;
    }
  }

  @media screen and (min-width: 1766px) {
    .main {
      max-width: 1551px;
      height: 780px;
      // transform: translateY(50px);
      margin: 25px auto 16px;
    }
    .main .left,
    .main .right {
      height: 100%;
    }
  }
</style>
